import { StackedGroupBarChart } from "@jana-technology/platform-ui";

import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { usePublishedRiskUnitFormatter } from "hooks/usePublishedRiskUnitFormatter";
import { useSystemOverviewTotalCharts } from "hooks/queries";
import { xAccessor } from "helpers/charts";

import { ChartCard } from "components/charts/ChartCard";
import { TopRiskWellsByThreatOperational } from "components/charts/TopRiskWellsOperational";
import {
  BASE_BAR_CHART_PROPS,
  LG_BAR_CHART_SIZE,
  MD_BAR_CHART_SIZE,
} from "constants/charts";

export const SystemOverviewOperationalCharts = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();
  const yTickFormatter = usePublishedRiskUnitFormatter();

  const systemOverviewTotalCharts = useSystemOverviewTotalCharts({
    variables: { hierarchyIds: hierarchyIdsOverview },
  });

  const chartSize =
    window.innerWidth <= 1600 ? MD_BAR_CHART_SIZE : LG_BAR_CHART_SIZE;
  const barChartProps = {
    ...BASE_BAR_CHART_PROPS,
    ...chartSize,
    yTickFormatter,
  };

  return (
    <div className="mb-4 flex flex-col gap-10">
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading="Risk by Threat"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          data={systemOverviewTotalCharts.threatORTab}
          dataKeys={systemOverviewTotalCharts.threatORDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading="Risk by Consequence"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          data={systemOverviewTotalCharts.consequenceORTab}
          dataKeys={systemOverviewTotalCharts.consequenceORDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading="Risk by Outcome Scenario"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Outcome Scenario"
          xAccessor={xAccessor}
          data={systemOverviewTotalCharts.outcomeORTab}
          dataKeys={systemOverviewTotalCharts.outcomeORDataKeys}
        />
      </ChartCard>
      <TopRiskWellsByThreatOperational />
    </div>
  );
};

export default SystemOverviewOperationalCharts;
